// extracted by mini-css-extract-plugin
module.exports = {"container":"Dbwt","image":"MS5J"};